import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router'
import { AppComponent } from './app.component';
import { SubMenuComponent } from './components/sub-menu/sub-menu.component';
import { RubroComponent } from './components/rubro/rubro.component';
import { PreguntaComponent } from './components/pregunta/pregunta.component';
import { MenuComponent } from './components/menu/menu.component';
import { MisRevisionesComponent } from './components/mis-revisiones/mis-revisiones.component';
import { SincronizarRevisionesComponent } from './components/sincronizar-revisiones/sincronizar-revisiones.component';
import { BloqueComponent } from './components/bloque/bloque.component';
import { EvidenciasComponent } from './components/evidencias/evidencias.component';
import { ChecklistValidacionComponent } from './pages/seguimiento/checklist-validacion/checklist-validacion.component';
import { ChecklistConfiguracionComponent } from './pages/configuracion/checklist-configuracion/checklist-configuracion.component';
import { ChecklistPaso1Component } from './pages/configuracion/checklist-paso1/checklist-paso1.component';
import { ChecklistPaso2Component } from './pages/configuracion/checklist-paso2/checklist-paso2.component';
import { ChecklistPaso3Component } from './pages/configuracion/checklist-paso3/checklist-paso3.component';
import { ChecklistPaso4Component } from './pages/configuracion/checklist-paso4/checklist-paso4.component';
import { ChecklistPaso5Component } from './pages/configuracion/checklist-paso5/checklist-paso5.component';
import { ChecklistPaso6Component } from './pages/configuracion/checklist-paso6/checklist-paso6.component';
import { ProyectService } from './components/proyect.service';
import { LoginComponent } from './components/login/login.component';
import { CrudComponent } from './components/crud/crud.component';
import { ChecklistDetalleComponent } from './pages/configuracion/checklist-detalle/checklist-detalle.component';
import { LogsComponent } from './components/logs/logs.component';
import { LayoutComponent } from './components/layout/layout.component';
import { CheckLoggedGuard } from './common/guards/check-logged.guard';
import { CheckchildGuard } from './common/guards/checkchild.guard';
import { LoginoktaComponent } from './components/login-okta/login_okta.component';
import { EstacionesTVADB } from './DAO/EstacionesTVADB';
import { Utilerias } from './helpers/Utilerias';
import { Oauth } from './helpers/Oauth';
import { MasterDB } from './DAO/MasterDB';
import { CrudHttp } from './helpers/CrudHttp';
import { PlaneacionComponent } from './pages/planeacion/planeacion.component';
import { TipoRevisionesComponent } from './pages/configuracion/tipo-revisiones/tipo-revisiones.component';
import { UsuariosComponent } from './pages/configuracion/usuarios/usuarios.component';
import { FormConfigUserComponent } from './components/form-config-user/form-config-user.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { FormNewRevisionComponent } from './components/form-new-revision/form-new-revision.component';
import { FormEditRevisionComponent } from './components/form-edit-revision/form-edit-revision.component';
import { CarteraRevisionesComponent } from './pages/seguimiento/cartera-revisiones/cartera-revisiones.component';
import { FormCarteraRevisonesComponent } from './components/form-cartera-revisones/form-cartera-revisones.component';
import { FormNewQuestionComponent } from './components/form-new-question/form-new-question.component';
import { FormSearchUserComponent } from './components/form-search-user/form-search-user.component';
import { FormDuplicarChecklistComponent } from './components/form-duplicar-checklist/form-duplicar-checklist.component';
import { PoliticasPrivacidadComponent } from './components/politicas-privacidad/politicas-privacidad.component';
import { MarkdownModule } from 'ngx-markdown';

const rutas: Routes = [
  { path: '', redirectTo: 'Login', pathMatch: 'full' },
  { path: 'Login', component: LoginComponent, canActivate: [CheckLoggedGuard] },
  { path: 'login_okta', component: LoginoktaComponent, canActivate: [CheckLoggedGuard] },  
  {
    path: 'Planeacion', component: LayoutComponent, canActivate: [CheckLoggedGuard],
    children: [
      { path: '', component: PlaneacionComponent, canActivateChild: [CheckchildGuard] },
    ]
  },
  {
    path: 'Configuracion', component: LayoutComponent, canActivate: [CheckLoggedGuard],
    children: [
      { path: '', component: TipoRevisionesComponent, canActivateChild: [CheckchildGuard] },
      { path: 'Usuarios', component: UsuariosComponent, canActivateChild: [CheckchildGuard] },
      { path: 'ChecklistConfiguracion/:id', component: ChecklistConfiguracionComponent, canActivateChild: [CheckchildGuard] },
      { path: 'ChecklistDetalle/:id', component: ChecklistDetalleComponent, canActivateChild: [CheckchildGuard] },
      { path: 'ChecklistPaso1/:id/:idrevision', component: ChecklistPaso1Component, canActivateChild: [CheckchildGuard] },
      { path: 'ChecklistPaso2/:id/:idrevision', component: ChecklistPaso2Component, canActivateChild: [CheckchildGuard] },
      { path: 'ChecklistPaso3/:id/:idrevision', component: ChecklistPaso3Component, canActivateChild: [CheckchildGuard] },
      { path: 'ChecklistPaso4/:id/:idrevision', component: ChecklistPaso4Component, canActivateChild: [CheckchildGuard] },
      { path: 'ChecklistPaso5/:id/:idrevision', component: ChecklistPaso5Component, canActivateChild: [CheckchildGuard] },
      { path: 'ChecklistPaso6/:id/:idrevision', component: ChecklistPaso6Component, canActivateChild: [CheckchildGuard] },
    ]
  },
  {
    path: 'Seguimiento', component: LayoutComponent, canActivate: [CheckLoggedGuard],
    children: [
      { path: '', component: CarteraRevisionesComponent, canActivateChild: [CheckchildGuard] },
      { path: 'ChecklistValidacion/:id', component: ChecklistValidacionComponent, canActivateChild: [CheckchildGuard] },
    ]
  },
  {
    path: 'Logs', component: LayoutComponent, canActivate: [CheckLoggedGuard],
    children: [
      { path: '', component: LogsComponent, canActivateChild: [CheckchildGuard] },
    ]
  },
  {
    path: 'PoliticasPrivacidad', component: PoliticasPrivacidadComponent,    
  }
]

@NgModule({
  declarations: [
    AppComponent,
    SubMenuComponent,
    RubroComponent,
    PreguntaComponent,
    MenuComponent,
    MisRevisionesComponent,
    SincronizarRevisionesComponent,
    BloqueComponent,
    EvidenciasComponent,
    CarteraRevisionesComponent,
    ChecklistValidacionComponent,
    ChecklistConfiguracionComponent,
    ChecklistPaso1Component,
    ChecklistPaso2Component,
    ChecklistPaso3Component,
    ChecklistPaso4Component,
    ChecklistPaso5Component,
    ChecklistPaso6Component,
    ChecklistPaso6Component,
    LoginComponent,
    CrudComponent,
    ChecklistDetalleComponent,
    LogsComponent,
    LayoutComponent,
    TipoRevisionesComponent,
    UsuariosComponent,
    PlaneacionComponent,
    FormConfigUserComponent,
    FormNewRevisionComponent,
    FormEditRevisionComponent,
    FormCarteraRevisonesComponent,
    FormNewQuestionComponent,
    FormSearchUserComponent,
    FormDuplicarChecklistComponent,
    PoliticasPrivacidadComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    ReactiveFormsModule,
    FormsModule,
    RouterModule.forRoot(rutas, { useHash: true }),
    InfiniteScrollModule,
    MarkdownModule.forRoot(),
  ],
  providers: [
    ProyectService,
    CheckLoggedGuard,
    CheckchildGuard,
    EstacionesTVADB,
    Utilerias,
    Oauth,
    MasterDB,
    CrudHttp
  ],

  bootstrap: [AppComponent]
})

export class AppModule { }
